import axiosClient from './axiosClient';
import { endpoints } from './endpoints';

export const getLinkedAccount = async () => {
  const resp = await axiosClient.get(endpoints.linkedAccount);
  return resp.data;
};
